import React from 'react';
import { cn } from '../../lib/utils';

export function Card({ children, className, ...props }) {
  return (
    <div className={cn("rounded-lg border border-slate-200 bg-white text-slate-950 shadow-sm dark:border-slate-800 dark:bg-slate-900 dark:text-slate-50", className)} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ children, className, ...props }) {
  return <div className={cn("flex flex-col space-y-1.5 p-6", className)} {...props}>{children}</div>;
}

export function CardTitle({ children, className, ...props }) {
  return <h3 className={cn("font-semibold leading-none tracking-tight", className)} {...props}>{children}</h3>;
}

export function CardContent({ children, className, ...props }) {
  return <div className={cn("p-6 pt-0", className)} {...props}>{children}</div>;
}